// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"57114d69","44":"b0aadfd5","484":"138941f5","516":"70b46801","564":"160fe569","584":"40fe5716","764":"84a9ba49"}[chunkId] + ".chunk.js";
};